import { Box, Group } from '@byecode/ui'
import { DataSourceType } from '@lighthouse/core'
import { SelectDataSource } from '@lighthouse/shared'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

interface DefaultDataSourceProps {
    enableAggregate?: boolean
}

/** 视图字段 */
export const DefaultDataSource: React.FC<DefaultDataSourceProps> = ({ enableAggregate }) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    const { control } = useFormContext()
    const dataSourceAllList = useDataSourceList(appId, envId)
    const dataSourceList = useMemo(() => {
        return enableAggregate ? dataSourceAllList : dataSourceAllList.filter(item => item.type !== DataSourceType.aggregateDataSource)
    }, [dataSourceAllList, enableAggregate])

    return (
        <Group label="数据来源">
            <Box px={8}>
                <Controller
                    name="pointer"
                    control={control}
                    render={({ field }) => {
                        return (
                            <SelectDataSource
                                withinPortal
                                placeholder="请选择数据表"
                                value={field.value}
                                onChange={field.onChange}
                                searchable
                                width="100%"
                                dataSourceList={dataSourceList}
                            />
                        )
                    }}
                />
            </Box>
        </Group>
    )
}
